import { useBrPageContext } from '../context/context.js';
import { getBrPageContent } from '../utils/get-br-page-content.js';

const mapButtonStyle = (buttonStyle = '')=>{
    const [colorMap, variantMap] = buttonStyle.split(' ');
    const color = colorMap;
    const variant = variantMap;
    return {
        color,
        variant
    };
};
const emptyContentBlock = {
    contentBlock: undefined,
    color: undefined,
    variant: undefined
};
const useGetCtaButtonComponent = ()=>{
    var ref, ref1;
    const page = useBrPageContext();
    if (!page) {
        return emptyContentBlock;
    }
    const mainDocumentReference = (ref = page.getComponent('main', 'content')) === null || ref === void 0 ? void 0 : ref.getModels().document;
    if (!mainDocumentReference) {
        return emptyContentBlock;
    }
    if (!mainDocumentReference.$ref) {
        return emptyContentBlock;
    }
    const ctaButtonContentBlock = (ref1 = getBrPageContent(page, mainDocumentReference)) === null || ref1 === void 0 ? void 0 : ref1.ctabuttonCompound;
    const { color , variant  } = mapButtonStyle(ctaButtonContentBlock === null || ctaButtonContentBlock === void 0 ? void 0 : ctaButtonContentBlock.buttonStyling);
    return {
        contentBlock: ctaButtonContentBlock,
        color,
        variant
    };
};

export { useGetCtaButtonComponent };
//# sourceMappingURL=use-get-cta-button-component.js.map
